import React, { useEffect, useState } from 'react';

import {
  Chart as ChartJS,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip as TooltipChartJS,
  SubTitle,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import { getAnalyticsAPI } from '@/api/getAnalytics';

ChartJS.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  TooltipChartJS,
  SubTitle
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
    },
  },
  scales: {
    yAxes: {
      ticks: {
        beginAtZero: true,
        precision: 0,
      },
    },
  },
};

export default function FileAnalytics({ fileUuid }: { fileUuid: string }) {
  const [analyticsData, setAnalyticsData] = useState(null);

  const fetchData = async () => {
    try {
      const res = await getAnalyticsAPI(fileUuid);

      const viewData = res.data.dataPoints
        .filter((d: any) => d.eventName === 'view')
        .map((d: any) => ({
          y: d.count,
          x: d.dateLabel,
        }));

      const downloadData = res.data.dataPoints
        .filter((d: any) => d.eventName === 'download')
        .map((d: any) => ({
          y: d.count,
          x: d.dateLabel,
        }));

      setAnalyticsData({
        datasets: [
          {
            label: 'Views',
            data: viewData,
            borderColor: 'black',
            backgroundColor: 'black',
            borderWidth: 2,
            pointRadius: 1,
          },
          {
            label: 'Downloads',
            data: downloadData,
            borderColor: 'blue',
            backgroundColor: 'blue',
            borderWidth: 2,
            pointRadius: 1,
          },
        ],
      });
    } catch (err) {
      //
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fileUuid]);

  return (
    analyticsData && (
      <Line datasetIdKey="id" options={options} data={analyticsData} />
    )
  );
}
